import React from "react";
import Header from "../components/Header";

const Home = () => {
    return (
        <Header title="Willkommen auf meiner Website" lead="Dies ist die Startseite." cta_text="Andere Seiten" cta_link="/"/>
    );
};

export default Home;